/* eslint-disable no-console */
import React from 'react';
import groupBy from 'lodash.groupby';
import styles from './index.module.scss';
import { AccordionItem, Button } from '@ui-elements';
import { SearchViewModel } from '../../../models/search-model';
import ChevronRight from '~/common/components/ui-elements/svg-icon/svgs/ChevronRight';

interface SearchWithNoResultProps {
  props: SearchViewModel;
}

const SearchWithNoResult: React.FC<SearchWithNoResultProps> = ({ props }) => {
  return (
    <div id="search-no-result">
      <div className={styles.message}>
        <p>
          <b>{`We've searched high and low... and nothing!`}</b>
        </p>
        <p>
          {`Try rewording what you're looking for or search for something else`}
        </p>
      </div>
      <div className={styles.popularSearch}>
        <h3>Popular Searches</h3>
        <div className={styles.itemContainer}>
          {props.searchBanner?.map((item, index) => (
            <a
              key={index}
              href={item.url}
              className={styles.searchItem}
              target={item.target ?? '_self'}
            >
              <img src={item.thumbnail} alt={item.title} loading="lazy" />
              <span className={styles.innerBtn}>
                <h3>{item.title}</h3>
                <i>
                  <ChevronRight
                    color="#000000"
                    className={styles.ChevronRight}
                  />
                </i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchWithNoResult;
